module.exports = Jsw.skinUrl + "/images/search-input.png?9fd99cb66354e116893e88b4f234ca6d";